var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 14,
    viewBox: "0 0 4 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4509_14622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2.09119C3.5 1.26276 2.82843 0.591187 2 0.591187C1.17157 0.591187 0.5 1.26276 0.5 2.09119C0.5 2.91961 1.17157 3.59119 2 3.59119C2.82843 3.59119 3.5 2.91961 3.5 2.09119Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 7.09119C3.5 6.26276 2.82843 5.59119 2 5.59119C1.17157 5.59119 0.5 6.26276 0.5 7.09119C0.5 7.91961 1.17157 8.59119 2 8.59119C2.82843 8.59119 3.5 7.91961 3.5 7.09119Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 12.0912C3.5 11.2628 2.82843 10.5912 2 10.5912C1.17157 10.5912 0.5 11.2628 0.5 12.0912C0.5 12.9196 1.17157 13.5912 2 13.5912C2.82843 13.5912 3.5 12.9196 3.5 12.0912Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4509_14622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 3,
    fill: "white",
    transform: "matrix(0 -1 1 0 0.5 13.5912)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.702483deccd9558bf67cf214064300d7.svg";
export { ForwardRef as ReactComponent };